<div>

  <div class="navbar-div">
    <app-web-navbar></app-web-navbar>
  </div>

  <div class="mobile-navbar">
    <app-sidebar></app-sidebar>
  </div>

  <div class="flex-container" style="background-color: #171717;">
    <div class="main-div secondrow" style="padding: 20px; width: 100%;">
      <span id="second-row-heading" style="color: white;font-weight: 400;font-size: 300%;">Host Screening Parties
      </span>
    </div>
    <mat-horizontal-stepper *ngIf="!isInvitation" [linear]="isLinear" labelPosition="bottom"
      style="background-color: #171717; color: white; margin-top: 20px;" #stepper>
      <mat-step [stepControl]="firstFormGroup">
        <ng-template matStepLabel>
          <mat-icon svgIcon="{{filmIcon}}"
            style="height: 50px; width: 50px; margin-left: -1px; margin-top: -5px; background: #171717;"></mat-icon>
        </ng-template>
        <div style="display: flex; justify-content: center;">
          <h1>What are we Watching?</h1>
        </div>
        <form [formGroup]="firstFormGroup">
          <div>
            <mat-form-field> 
              <label for="screeningPartyType">Type Of Screening Party &nbsp;</label>
              <mat-select formControlName="screeningPartyType" class="form-control"
                (selectionChange)="updateMovieList($event)">
                <mat-option *ngFor="let name of screeningPartyTypes" [value]="name">{{screeningPartyType[name]}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <label for="cinejoyFeaturedMovie">Enter Showcase Movie or Spotlight Event</label>
              <mat-select formControlName="cinejoyFeaturedMovie" class="form-control">
                <ng-container>
                  <mat-option [hidden]="!isSpotlightSelected()" *ngFor="let movie of spotlightList"
                    [value]="movie['eventId']">{{movie.name}}</mat-option>
                </ng-container>
                <ng-container>
                  <mat-option [hidden]="!isShowcaseSelected()" *ngFor="let movie1 of showcaseList"
                    [value]="movie1['id']">{{movie1.name}}</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <label for="mobileNumber">Mobile for Cinejoy Internal Use Only</label>
              <input matInput type="tel" formControlName="mobileNumber" style="background: white; width: 100%;" />
            </mat-form-field>
          </div>
          <div>
            <button class="btn action-button" style="align-self: right; width: 100px;
            background: #da2c43;
            font-weight: bold;
            color: white;
            border: 0 none;
            border-radius: 5px;
            cursor: pointer;
            padding: 10px 5px;
            margin: 10px 0px 10px 5px;
            float: right;" matStepperNext>Next</button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="secondFormGroup">
        <div style="display: flex; justify-content: center;">
          <h1>Date and Time</h1>
        </div>
        <form [formGroup]="secondFormGroup">
          <ng-template *ngIf="getCurrentStep()<1" matStepLabel>
            <mat-icon svgIcon="{{calendarIconWhite}}"
              style="height: 50px; width: 50px; margin-left: -1px; margin-top: -5px; background: #171717;"></mat-icon>
          </ng-template>
          <ng-template *ngIf="getCurrentStep()>=1" matStepLabel>
            <mat-icon svgIcon="{{calendarIconRed}}"
              style="height: 50px; width: 50px; margin-left: -1px; margin-top: -5px; background: #171717;"></mat-icon>
          </ng-template>
          <mat-form-field>
            <label for="meetingDateTime">Date and Time of Screening Party</label>
            <input matInput type="datetime-local" [min]="getCurrentDate()" formControlName="meetingDateTime"
              style="background: white;">
          </mat-form-field>
          <div>
            <button class="btn action-button" style="align-self: right; width: 100px;
            background: #999999;
            font-weight: bold;
            color: white;
            border: 0 none;
            border-radius: 5px;
            cursor: pointer;
            padding: 10px 5px;
            margin: 10px 0px 10px 5px;
            float: left;" matStepperPrevious>Back</button>
            <button class="btn action-button" style="align-self: right; width: 100px;
            background: #da2c43;
            font-weight: bold;
            color: white;
            border: 0 none;
            border-radius: 5px;
            cursor: pointer;
            padding: 10px 5px;
            margin: 10px 0px 10px 5px;
            float: right;" matStepperNext>Next</button>
          </div>
        </form>
      </mat-step>
      <mat-step [stepControl]="thirdFormGroup">
        <ng-template *ngIf="getCurrentStep()<2" matStepLabel>
          <mat-icon svgIcon="{{partyIconWhite}}"
            style="height: 50px; width: 50px; margin-left: -1px; margin-top: -5px; background: #171717;"></mat-icon>
        </ng-template>
        <ng-template *ngIf="getCurrentStep()==2" matStepLabel>
          <mat-icon svgIcon="{{partyIconRed}}"
            style="height: 50px; width: 50px; margin-left: -1px; margin-top: -5px; background: #171717;"></mat-icon>
        </ng-template>
        <div style="display: flex; justify-content: center;">
          <h1>Party Info</h1>
        </div>
        <form [formGroup]="thirdFormGroup" (ngSubmit)="submitScreeningParty()">
          <mat-form-field>
            <label for="meetingType">Platform for Party Meeting/Event</label>
            <mat-select formControlName="meetingType" class="form-control">
              <mat-option *ngFor="let name of meetingTypes" [value]="name">{{meetingType[name]}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <label for="meetingLink">Zoom Meeting or Gather Event URL</label>
            <input matInput type="url" formControlName="meetingLink" style="background: white;" />
          </mat-form-field>
          <mat-form-field>
            <label for="meetingCapacity">Enter about 50% of your Meeting Capacity for Cinejoy Attendees (you invite the rest)</label>
            <input matInput id="myNumber" style="background: white;" formControlName="meetingCapacity" name="capacity"
              type="number" min="25" max="50" required value="50"/>
          </mat-form-field>
          <mat-form-field>
            <label for="description">Party Description</label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="10" cdkAutosizeMaxRows="10"
              style="margin-bottom: 11px" formControlName="description" style="background: white;"></textarea>
          </mat-form-field>

          <div>
            <button class="btn action-button" style="align-self: right; width: 100px;
          background: #999999;
          font-weight: bold;
          color: white;
          border: 0 none;
          border-radius: 5px;
          cursor: pointer;
          padding: 10px 5px;
          margin: 10px 0px 10px 5px;
          float: left;" matStepperPrevious>Back</button>
            <button type="submit" class="btn action-button" style="align-self: right; width: 100px;
          background: #da2c43;
          font-weight: bold;
          color: white;
          border: 0 none;
          border-radius: 5px;
          cursor: pointer;
          padding: 10px 5px;
          margin: 10px 0px 10px 5px;
          float: right;" mat-button>Submit</button>
          </div>
        </form>
      </mat-step>
    </mat-horizontal-stepper>
    <mat-horizontal-stepper class="invitation" *ngIf="isInvitation" [linear]="true" labelPosition="bottom"
      style="font-family: 'Poppins Regular' !important; background-color: #171717; color: white; margin-top: 20px;"
      #stepper>
      <mat-step>
        <ng-template matStepLabel>
          <mat-icon svgIcon="{{filmIcon}}"
            style="height: 50px; width: 50px; margin-left: -1px; margin-top: -5px; background: #171717;"></mat-icon>
        </ng-template>
        <app-screening-party-invitation screeningPartyId="{{invitationScreeningPartyId}}">
        </app-screening-party-invitation>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>
          <mat-icon svgIcon="{{calendarIconRed}}"
            style="height: 50px; width: 50px; margin-left: -1px; margin-top: -5px; background: #171717;"></mat-icon>
        </ng-template>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>
          <mat-icon svgIcon="{{partyIconRed}}"
            style="height: 50px; width: 50px; margin-left: -1px; margin-top: -5px; background: #171717;"></mat-icon>
        </ng-template>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
  <div class="footer-div web-view">
    <app-cinejoy-footer></app-cinejoy-footer>
  </div>
  <div class="mobile-view">
    <app-cinejoy-mobile-footer></app-cinejoy-mobile-footer>
  </div>


</div>
